/** A persisted selection is a routing hint. Workspace access is still checked server-side. */
export const MARKETPLACE_WORKSPACE_COOKIE = "venturu-workspace";

export function normalizeMarketplaceWorkspacePath(path: string): string | null {
  const segments = path.split(/[?#]/, 1)[0]?.split("/") ?? [];
  const context = segments[2];
  if (
    segments[0] !== "" ||
    segments[1] !== "os" ||
    !context ||
    !/^~?[a-z0-9-]+$/i.test(context)
  )
    return null;
  if (context.startsWith("~")) {
    if (segments[3] === "members" || segments[3] === "teams") return null;
    return `/os/${context}/dashboard`;
  }
  const member = segments[4];
  return segments[3] === "members" && member && /^[a-z0-9-]+$/i.test(member)
    ? `/os/${context}/members/${member}/dashboard`
    : null;
}

export function parseMarketplaceWorkspaceSelection(
  snapshot: string,
  actorUserId?: string | null,
): string | null {
  if (!actorUserId || !snapshot || snapshot.length > 2048) return null;
  try {
    const stored = JSON.parse(
      snapshot.startsWith("{") ? snapshot : decodeURIComponent(snapshot),
    );
    return stored?.actorUserId === actorUserId &&
      typeof stored.path === "string"
      ? normalizeMarketplaceWorkspacePath(stored.path)
      : null;
  } catch {
    return null;
  }
}

export function marketplaceRequestPath(input: {
  pathname?: string | null;
  actorUserId?: string | null;
  selectionCookie?: string;
  isDemo?: boolean;
}): string | null {
  if (
    input.isDemo ||
    input.pathname === "/os" ||
    input.pathname?.startsWith("/os/")
  )
    return input.pathname ?? null;
  return (
    parseMarketplaceWorkspaceSelection(
      input.selectionCookie ?? "",
      input.actorUserId,
    ) ??
    input.pathname ??
    null
  );
}
